import createUploadingPageLogger from "./uploading-page";
import createFinishedPageLogger from "./finished-page";
export default function createEndAssessmentLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `end:${input.type}` });
    return {
        detected(details) {
            return log({
                type: "submit-detected",
                details,
            });
        },
        notMatched(details) {
            return log({
                type: "not-matched",
                details: details,
            });
        },
        notifiedLms(details) {
            return log({
                type: "notified-lms",
                details,
            });
        },
        manuallyEnded(type) {
            return log({
                type: "manually-ended",
                details: { type },
            });
        },
        uploadingPage: createUploadingPageLogger(log),
        finishedPage: createFinishedPageLogger(log),
    };
}
